/**
 * Thin PostHog wrapper. PostHog itself is bootstrapped by the inline snippet in
 * public/index.html. This module provides the canonical event names so the
 * funnels in PostHog (signup → first chat → first report → paid) stay stable.
 *
 * Never import from this module in a hot render path — PostHog calls are fire-and-forget.
 */

const FUNNEL_EVENTS = {
  LANDING_VIEW: 'landing_view',
  LANDING_CTA_RETAIL: 'landing_cta_retail',
  LANDING_CTA_ADVISOR: 'landing_cta_advisor',
  SIGNUP_VIEW: 'signup_view',
  SIGNUP_SUBMITTED: 'signup_submitted',
  SIGNUP_SUCCESS: 'signup_success',
  LOGIN_SUCCESS: 'login_success',
  AI_CHAT_FIRST_MESSAGE: 'ai_chat_first_message',
  AI_CHAT_QUOTA_HIT: 'ai_chat_quota_hit',
  PITCH_REPORT_STARTED: 'pitch_report_started',
  PITCH_REPORT_VIEWED: 'pitch_report_viewed',
  BROKER_CONNECT_STARTED: 'broker_connect_started',
  BROKER_CONNECTED: 'broker_connected',
  BILLING_PLAN_VIEWED: 'billing_plan_viewed',
  BILLING_CHECKOUT_STARTED: 'billing_checkout_started',
  BILLING_TRIAL_STARTED: 'billing_trial_started',
  BILLING_SUBSCRIPTION_ACTIVE: 'billing_subscription_active',
  BILLING_CANCEL_REQUESTED: 'billing_cancel_requested',
  ADVISOR_CLIENT_CREATED: 'advisor_client_created',
  ADVISOR_PROPOSAL_GENERATED: 'advisor_proposal_generated',
  ADVISOR_PROPOSAL_APPROVED: 'advisor_proposal_approved',
};

function client() {
  return (typeof window !== 'undefined' && window.posthog) ? window.posthog : null;
}

export function track(event, properties) {
  try { client()?.capture(event, properties || {}); } catch { /* noop */ }
}

export function identify(user) {
  if (!user?.id) return;
  try {
    client()?.identify(user.id, {
      email: user.email,
      name: user.name,
      user_type: user.userType,
      // intentionally NO pan / NO broker data
    });
  } catch { /* noop */ }
}

export function resetAnalytics() {
  try { client()?.reset(); } catch { /* noop */ }
}

export { FUNNEL_EVENTS as EVT };
